/*eslint-disable*/
import { useState } from "react";

const useSort = ({ initialSortBy, initialSortOrder, setPage }) => {

  const [sortBy, setSortBy] = useState(initialSortBy);
  const [sortOrder, setSortOrder] = useState(initialSortOrder);

  const handleSort = (property) => {
    const newOrder =
      sortBy === property && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(property);
    setSortOrder(newOrder);
    setPage?.(0)
  };

  return {sortBy, sortOrder, handleSort };
};

export default useSort;
